"use strict";
module.exports = function () {

    return {
        require: 'ngModel',
        restrict: 'E',
        template: require('./noData.html'),
        controller: require('./noDataCtrl'),
        scope: {
            ngModel: '='
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/directives/noData/noData.js
// module id = 363
// module chunks = 0